import { render, staticRenderFns } from "./compWithdrawalList.vue?vue&type=template&id=450ed661&scoped=true"
import script from "./compWithdrawalList.vue?vue&type=script&lang=js"
export * from "./compWithdrawalList.vue?vue&type=script&lang=js"
import style0 from "./compWithdrawalList.vue?vue&type=style&index=0&id=450ed661&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450ed661",
  null
  
)

export default component.exports